import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import { BottomSheetContentLayout, ScrollableList } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useTutorialVideos } from '~/hooks/useTutorialVideos/useTutorialVideos';
import { useLocaleKeys } from '~/i18n';
import styles from './MobileTutorialVideos.module.scss';
import { TutorialVideosPlayedVideo } from './TutorialVideosPlayedVideo';
import { VideoCardItem } from './VideoCardItem/VideoCardItem';
export const getMobileTutorialVideosTID = ()=>getTestIds();
export function MobileTutorialVideos() {
    const { MobileTutorialVideosTID } = useMemo(()=>getMobileTutorialVideosTID(), []);
    const { t: tutorialVideosTexts } = useLocaleKeys('components.tutorialVideos');
    const { videos, handleWatch } = useTutorialVideos();
    const [currentVideo, setCurrentVideo] = useState(null);
    useEffect(()=>{
        if (videos.length > 0 && !currentVideo) {
            setCurrentVideo(videos[0]);
        }
    }, [
        currentVideo,
        videos
    ]);
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.scrollableList,
                        children: tutorialVideosTexts.exploreTutorials()
                    }),
                    currentVideo && /*#__PURE__*/ _jsx("div", {
                        className: styles.responsivePlayer,
                        children: /*#__PURE__*/ _jsx(TutorialVideosPlayedVideo, {
                            video: currentVideo,
                            onWatch: handleWatch
                        })
                    })
                ]
            }),
            paddingBottom: 8
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.root,
            "data-testid": MobileTutorialVideosTID.Root(),
            children: /*#__PURE__*/ _jsx(ScrollableList, {
                direction: "vertical",
                maxSize: "100%",
                gap: 8,
                className: styles.scrollableList,
                children: videos.map((video)=>/*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(VideoCardItem, {
                            video: video,
                            onSelect: setCurrentVideo,
                            isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === video.id,
                            variant: "mobile"
                        })
                    }, video.id))
            })
        })
    });
}
